import { render, staticRenderFns } from "./documents-table.vue?vue&type=template&id=203d1821&scoped=true"
import script from "./documents-table.vue?vue&type=script&lang=js"
export * from "./documents-table.vue?vue&type=script&lang=js"
import style0 from "./documents-table.vue?vue&type=style&index=0&id=203d1821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d1821",
  null
  
)

export default component.exports